import { render, staticRenderFns } from "./YearlyOrdersConsolidation.vue?vue&type=template&id=8541981e&"
import script from "./YearlyOrdersConsolidation.vue?vue&type=script&lang=js&"
export * from "./YearlyOrdersConsolidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports